export const actionType = {
  LOGIN_AUTH_REQUEST: 'LOGIN_AUTH_REQUEST',
  LOGIN_AUTH_SUCCESS: 'LOGIN_AUTH_SUCCESS',
  LOGIN_AUTH_FAILURE: 'LOGIN_AUTH_FAILURE'
}
export const checkAuthAction = () => ({
  type: actionType.LOGIN_AUTH_REQUEST,
});